(function(){
  angular
       .module('irricrops')
  .controller("vinedoCtrl", ['vinedo',
    function(vinedo){
  }]);

})();
